import PropTypes from 'prop-types';

import { CurrencyPropType } from './currency';

export const AdditionalShippingOptionsPropType = PropTypes.shape({
  additionalOptionEnum: PropTypes.string,
  additionalOptionValue: PropTypes.shape({
    prepaidDuty: PropTypes.string,
    price: CurrencyPropType,
  }),
});

/**
 * @typedef {import('./currency').Currency} Currency
/**
 * @typedef {object} AdditionalShippingOptions
 * @property {string} additionalOptionEnum
 * @property {{ prepaidDuty: string, price: Currency }} additionalOptionValue
 */
